import React from 'react';
import './TitleBar.css';

class TitleBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      actionsState: 'closed',
    };
  }
  render() {
    return (
      <div className="titleBar">
        <div className="row">
          <div className="col-sm-8">
            <h2>{this.props.title}</h2>
          </div>
          {this.props.actions && this.props.actions.length > 0 ? (
            <div className="col-sm-4 d-flex justify-content-end">
              <div className={'actionsContainer ' + this.state.actionsState}>
                <button
                  title="Filtra i risultati"
                  onClick={() => {
                    this.setState({
                      actionsState: this.state.actionsState == 'closed' ? 'open' : 'closed',
                    });
                  }}
                >
                  <span className={'fa-solid fa-' + (this.props.actionsIcon || 'filter')}></span>
                </button>
                <div className="actions">
                  <div className="actionsBorders">
                    {this.props.actions.map((action) => {
                      return action;
                    })}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    );
  }
}

export default TitleBar;
